import React from 'react'
import styled from 'styled-components'

import { theme } from '../../../theme'
import { IconGenerator } from '../../uikit/IconGenerator'

import type { IconGeneratorProps } from '../../uikit/IconGenerator'
import type { PropsWithChildren } from 'react'

export type InformationSectionProps = PropsWithChildren<{
  title?: string
  iconProps?: IconGeneratorProps
}>

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;

  background: ${theme.colors.lightBg};
  border-radius: 16px;

  font-weight: ${theme.fontWeight.light};
  text-align: center;
`

export const InformationSectionTitle = styled.h1`
  font-family: ${theme.fonts.itcGothicPro};
  font-weight: ${theme.fontWeight.semiBold};
  font-size: ${theme.fontSize.xl};
  margin-bottom: 8px;
  text-align: center;
`

const IconContainer = styled.div`
  margin-bottom: 20px;
`

export const InformationSection = ({
  title,
  iconProps,
  children,
}: InformationSectionProps) => (
  <Wrapper>
    {iconProps && (
      <IconContainer>
        <IconGenerator {...iconProps} />
      </IconContainer>
    )}
    {title && <InformationSectionTitle>{title}</InformationSectionTitle>}
    {children}
  </Wrapper>
)
